/*
 * Copyright (c)  CYBERKOALA LLC 2025.
 * Proprietary License.
 * Redistribution and use in source and binary forms, with or without
 * modification, are restricted.
 */
import React, { useEffect, useState } from 'react';
import { GlobalAudioContext } from './global-audio-context.tsx';
import { useSettings } from '../settings-context/settings-context.ts';

/**
 * @param children
 * @constructor
 */
export const GlobalAudioProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isSpeaking, setIsSpeaking] = useState(false);
  const [volumeLevel, setVolumeLevel] = useState(0);
  const { selectedAudioInputDeviceId } = useSettings();

  const [deviceId, setDeviceId] = useState<string | undefined>(() => {
    return selectedAudioInputDeviceId || undefined;
  });

  // Sync deviceId with selectedAudioInputDeviceId
  useEffect(() => {
    if (deviceId !== selectedAudioInputDeviceId) {
      setDeviceId(selectedAudioInputDeviceId);
    }
  }, [selectedAudioInputDeviceId, deviceId]);

  return (
    <GlobalAudioContext.Provider
      value={{ isSpeaking, setIsSpeaking, volumeLevel, setVolumeLevel, deviceId, setDeviceId }}
    >
      {children}
    </GlobalAudioContext.Provider>
  );
};
